import React, { Component } from 'react';
class Banner extends Component {
    state = {  }
    render() { 
        return (
            <React.Fragment>
            <header className="header">
                <div className="interior-banner">
                    <div className="header-green-container"></div>
                    <div className="banner-text">
                        <div className="banner-title">
                            <h1 className="fuente-monserrat"> Diseño Interior</h1>
                        </div>
                        {/* <div className="banner-descrip parrafo-grande">
                            <p align="justify" className="fuente-monserrat">
                                La carrera de Diseño Interior forma profesionales capaces de ambientar los espacios arquitectónicos, evaluando el contexto y atendiendo los requerimientos del cliente y las necesidades del usuario, bajo los estándares establecidos de confort, ergonomía y sostenibilidad, con sólidos fundamentos técnicos, funcionales y artísticos.
                            </p>
                        </div>
                        <div>
                            <a className="btn btn-danger fuente-monserrat" href="docs/PlanDInterior.pdf" target="_blank" style={{borderWidth: 1, borderColor:"#a80012", backgroundColor:"#a80012", color:"#FFF"}} title="Descargar el Plan de Estudios">Plan de Estudio <i className="fa fa-download"></i></a>
                        </div> */}
                    </div>
                </div>
            </header>
            </React.Fragment>
        );
    }
}
 
export default Banner;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoInterior/Banner.jsx